import { useEffect, useState } from "react";
import { StudentLayout } from "@/components/Layouts";
import { RecordingCard } from "@/components/RecordingCard";
import { EmptyState } from "@/components/EmptyState";
import { Video } from "lucide-react";
import api from "@/lib/api";

export default function StudentRecordings() {
  const [recordings, setRecordings] = useState([]);
  useEffect(() => {
    api.get("/recordings").then((r) => setRecordings(r.data)).catch(() => {});
  }, []);

  return (
    <StudentLayout title="Class Recordings">
      <div className="mb-5">
        <h1 className="text-3xl font-heading font-bold tracking-tight">Class Recordings</h1>
        <p className="mt-2 text-muted-foreground">
          Re-watch the class session recordings.
        </p>
      </div>
      {recordings.length === 0 ? (
        <EmptyState icon={Video} title="Class recordings are not yet available." description="Please check again after class has ended and admin uploads the recordings." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {recordings.map((r) => <RecordingCard key={r.id} recording={r} />)}
        </div>
      )}
    </StudentLayout>
  );
}
